import domain from "./domain";

export const resetWorkspaces = domain.createEvent("resetWorkspaces");
